import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ActionService } from '../actions/action.service';
import { PermissionType } from 'src/app/models/user';
import { UserPermissionService } from '../user/user-permission.service';
import { MemberService } from '../member/member.service';

@Injectable({
    providedIn: 'root'
})
export class UserViewsService {

    ActionType: string = "UserView";
    public userViewCount$ = new BehaviorSubject<number>(0);
    public viewConfig$ = new BehaviorSubject<any>(undefined);
    permissions: any;
    refreshInterval: any;

    constructor(private readonly actionService: ActionService,
        private readonly userPermissionService: UserPermissionService,
        public readonly memberService: MemberService) {

        this.initialize();
    }

    async initialize() {

        await this.userPermissionService.registerPermissions([{ selectionName: 'UI.UserView', permissionType: PermissionType.namespace }]);
        this.permissions = this.userPermissionService.getPermissionsByNameSpace('UI.UserView').map(p => p.permission.name);

        let action = await this.actionService.initializeV2<any>(this.ActionType, {});
        await this.setRefreshInterval(action.refreshInterval);
    }

    async setRefreshInterval(refreshInterval: number) {

        await this.getViews();

        setInterval(async () => {
            await this.getViews();
        }, refreshInterval);
    }

    async getViews() {
        if (this.permissions) {
            let items = await this.actionService.invoke(this.ActionType, "get-views", { permissions: this.permissions });
            await this.setUserViewCount(items);
            this.viewConfig$.next(items);
        }
    }

    async setUserViewCount(viewConfig: any) {
        let totalCount = 0;
        viewConfig?.views?.forEach(view => {
            totalCount += view.count;
        })
        this.userViewCount$.next(totalCount);
    }

    async checkInItem(tenantId: string, id: number) {
        await this.actionService.invoke(this.ActionType, "checkin", { UserInstanceId: id, TenantId: tenantId });
    }
}
